module.exports = __webpack_public_path__ + "static/media/B_H.e41871b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/B_H.jpg
// module id = 457
// module chunks = 0